import { MATH_ENROLMENT_SURFACE, MATH_REFERRAL_PROGRAM_KEY } from '../constants/mathPromo';
import { SEPTEMBER_SCRAMBLE_PROGRAM_KEY } from '../constants/septemberScramble';

/**
 * The "gift a free year" ask, as an ad descriptor's `modal` field — the share
 * offered to a teacher who has already claimed the math free-year offer.
 *
 * A different ask from shareReferralModal, not a differently-worded one: it
 * sends invites against the MATH campaign, and it names a bonus campaign, which
 * swaps the modal's "See your rewards" link for the swag footnote.
 *
 * The two program keys are what this module exists to hold. They must stay
 * separate and they must not drift: invites go against `bts_2026_math` while
 * the footnote is gated on `bts_2026_september_scramble`. One key doing both
 * jobs hands hasPayableBonusTier the wrong campaign, which fails closed exactly
 * like "no program" — so the footnote silently stops and nobody notices.
 *
 * `enrolmentSurface` is what makes the modal POST /referral/enroll on open, and
 * this caller needs it where the generic referral ask does not: every account is
 * already in the September Scramble, but nothing enrols anyone in bts_2026_math.
 * A teacher who claimed the offer through /redeem — the link the campaign itself
 * hands out — holds the nux flag that makes this card eligible while belonging to
 * no program, so without this their invites earn them nothing and say so nowhere.
 * Enrolment is idempotent and keeps the original assignment date.
 *
 * Copy is a parameter rather than baked in. Surfaces start aligned because the
 * ask is the same, but each is free to word it for its own shape later; the
 * wiring above is the part that is not free to differ.
 */
export const mathShareModal = ({ ariaLabel, subhead, inviteSource, trackingPrefix }) => ({
  key: 'shareReferral',
  props: {
    ariaLabel,
    subhead,
    enrolmentSurface: MATH_ENROLMENT_SURFACE,
    inviteProgramKey: MATH_REFERRAL_PROGRAM_KEY,
    inviteSource,
    bonusProgramKey: SEPTEMBER_SCRAMBLE_PROGRAM_KEY,
    trackingPrefix,
  },
});
